import {
    faCalendar,
    faGear,
    faKey,
    faLock,
    faNoteSticky,
    faScrewdriverWrench,
    faSignal,
    faTicket,
} from '@fortawesome/free-solid-svg-icons';
import { createStackNavigator } from '@react-navigation/stack';
import { Module } from '../Routes';
import { UserSchemas } from '../schemas/user';
import { UserParamList } from '../typings/Params';

import Account from '../pages/user/Account';
import Notes from '../pages/user/Notes';
import Password from '../pages/user/Password';
import Sessions from '../pages/user/Sessions';
import Calendar from '../pages/user/Calendar';
import OwnSupportTickets from '../pages/user/OwnSupportTickets';
import GetOwnSupportTicket from '../pages/user/GetOwnSupportTicket';
import ConnectionDiagnostics from '../pages/user/ConnectionDiagnostics';
import OwnMaintenanceRequests from '../pages/user/OwnMaintenanceRequests';
import GetOwnMaintenanceRequest from '../pages/user/GetOwnMaintenanceRequest';


export const userModule: Module<'User'> = {
    path: '/user',
    stackNavigator: createStackNavigator<UserParamList>(),
    canAccess: (user) => Boolean(user),
    hideFromMenu: true,
    label: 'settings',
    navigate: (navigation) => navigation.navigate('User'),
    schemas: UserSchemas,
    screens: {
        Account: {
            path: 'account',
            selectedItem: 'account',
            component: Account,
            canAccess: () => true,
            label: 'account',
            accessInformation: {
                icon: faGear,
                navigate: navigation => navigation.navigate('User', { screen: 'Account' })
            },
        },
        Password: {
            path: 'password',
            selectedItem: 'password',
            component: Password,
            canAccess: () => true,
            label: 'changePassword',
            accessInformation: {
                icon: faKey,
                navigate: navigation => navigation.navigate('User', { screen: 'Password' })
            },
        },
        Sessions: {
            path: 'sessions',
            selectedItem: 'sessions',
            component: Sessions,
            canAccess: () => true,
            label: 'sessions',
            accessInformation: {
                icon: faLock,
                navigate: navigation => navigation.navigate('User', { screen: 'Sessions' })
            },
        },
        Calendar: {
            path: 'calendar',
            selectedItem: 'calendar',
            component: Calendar,
            canAccess: () => true,
            label: 'calendar',
            accessInformation: {
                icon: faCalendar,
                navigate: navigation => navigation.navigate('User', { screen: 'Calendar' })
            },
        },
        Notes: {
            path: 'notes',
            selectedItem: 'notes',
            component: Notes,
            canAccess: () => true,
            label: 'notes',
            accessInformation: {
                icon: faNoteSticky,
                navigate: navigation => navigation.navigate('User', { screen: 'Notes' })
            },
        },
        OwnSupportTickets: {
            path: 'support-tickets',
            selectedItem: 'support-tickets',
            component: OwnSupportTickets,
            canAccess: (user) => Boolean(
                user?.permissions.create_support_ticket
                || user?.permissions.manage_support_tickets
            ),
            label: 'myTicket',
            accessInformation: {
                icon: faTicket,
                navigate: navigation => navigation.navigate('User', { screen: 'OwnSupportTickets' })
            },
            initialParams: () => ({
                page: 1,
                limit: 25,
            })
        },
        GetOwnSupportTicket: {
            path: 'support-ticket/:id',
            selectedItem: 'support-tickets',
            component: GetOwnSupportTicket,
            canAccess: (user) => Boolean(
                user?.permissions.create_support_ticket
                || user?.permissions.manage_support_tickets
            ),
            label: 'myTicket',
        },
        ConnectionDiagnostics: {
            path: 'connection-diagnostics',
            selectedItem: 'connection-diagnostics',
            component: ConnectionDiagnostics,
            canAccess: (user) => Boolean(user?.permissions.access_can_run_diagnostics),
            label: 'connectionDiagnostics',
            accessInformation: {
                icon: faSignal,
                navigate: navigation => navigation.navigate('User', { screen: 'ConnectionDiagnostics' })
            },
        },
        OwnMaintenanceRequests: {
            path: 'maintenance-requests',
            selectedItem: 'maintenance-requests',
            component: OwnMaintenanceRequests,
            canAccess: () => true,
            label: 'maintenanceRequests',
            accessInformation: {
                icon: faScrewdriverWrench,
                navigate: navigation => navigation.navigate('User', { screen: 'OwnMaintenanceRequests' })
            },
            initialParams: () => ({
                page: 1,
                limit: 25,
                orderBy: 'start',
                orderDirection: 'desc',
                onlyClosed: false,
                onlyOffline: false,
            })
        },
        GetOwnMaintenanceRequest: {
            path: 'maintenance-request/:id',
            selectedItem: 'maintenance-requests',
            component: GetOwnMaintenanceRequest,
            canAccess: () => true,
            label: 'maintenanceRequests',
        },
    }
};
